module.exports = __webpack_public_path__ + "img/img_26.3b85d097.png";